module.exports = __webpack_public_path__ + "img/icb-leo-Inte-m@3x.804adfbd.png";